export default function ClickDiv({ onClick, children, ...otherProps }) {
  return (
    <div onClick={onClick} onKeyUp={onClick} {...otherProps} role="button">
      {children}
    </div>
  );
}
